import React from 'react';
import PropTypes from 'prop-types';
import {FmlxTooltip} from 'fmlx-common-ui';
import './SerialDilution.scss';
import Tube from '../Components/Tube/Tube';

function SerialDilutionSerialPlateTubes({serialPlateRefs, tubesProps, onDelete}) {
  const generateTubes = () => {
    const element = [];
    for (let i = 0; i < 4; i += 1) {
      element.push(
        <FmlxTooltip title={tubesProps[i]?.tooltip ?? ''} placement="top">
          <span>
            <Tube
              key={tubesProps[i]?.key ?? i}
              ref={(el) => {
                serialPlateRefs.current[i] = el;
              }}
              onDelete={() => onDelete(i)}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...tubesProps[i]}
            />
          </span>
        </FmlxTooltip>,
      );
    }

    return element;
  };

  return <div className="serial-dilution__content__serial-plates--tubes">{generateTubes()}</div>;
}

SerialDilutionSerialPlateTubes.propTypes = {
  serialPlateRefs: PropTypes.object.isRequired,
  tubesProps: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default SerialDilutionSerialPlateTubes;
